export default function DataGrid(theme) {
  return {
    MuiDataGrid: {
      styleOverrides: {
        columnHeaders: {
          backgroundColor: theme.palette.primary["darker"],
          color: "white",
        },
        columnHeader: {
          // minHeight: "min-content !important",
          // maxHeight: "max-content !important",
        },
        row: {
          backgroundColor: "white",
          minHeight: "none !important",
          maxHeight: "none !important",
          height: "auto",
          width: "auto",
        },

        cell: {
          minHeight: "min-content !important",
          maxHeight: "max-content !important",
        },
        cellContent: {
          minHeight: "min-content !important",
          maxHeight: "max-content !important",
          // textWrap: "wrap !important",
          overflow: "hidden",
          textOverflow: "unset",
          whiteSpace: "normal",
          wordWrap: "break-word",
          wordBreak: "break-all",
        },

        panel: {
          border: "1px solid black",
        },

        columnSeparator: {
          display: "none",
        },
        menuIcon: {
          display: "none",
        },

        root: {
          color: "black",
          fontWeight: 500,
          border: "none",
          fontSize: "1rem",
        },
        footerContainer: {
          display: "flex",
          justifyContent: "center",
        },
        virtualScrollerContent: {
          backgroundColor: "white",
        },
        virtualScroller: {},
      },
    },
  }
}
